import {
  Alert,
  Box,
  Card,
  CardContent,
  Grid,
  Icon,
  LinearProgress,
  Stack,
  Tab,
  Tabs,
  Typography
} from "@mui/material";
import { useState } from "react";

export function Indicadores({ items, compacto = false }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {items.map((item) => (
        <Grid
          item
          xs={6}
          md={compacto ? 6 : 12 / items.length}
          key={item.label}
        >
          <Card
            variant="outlined"
            sx={{
              height: "100%",
              borderRadius: 2
            }}
          >
            <CardContent>
              <Stack direction="row" justifyContent="space-between">
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ overflowWrap: "anywhere" }}
                >
                  {item.label}
                </Typography>
                {item.icon && (
                  <Icon sx={{ color: item.color || "primary.main" }}>
                    {item.icon}
                  </Icon>
                )}
              </Stack>
              <Typography
                variant="h4"
                sx={{
                  mt: 1,
                  fontWeight: 700,
                  fontSize: { xs: 24, md: 30 },
                  overflowWrap: "anywhere"
                }}
              >
                {item.value ?? "—"}
              </Typography>
              {item.caption && (
                <Typography variant="caption" color="text.secondary">
                  {item.caption}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export function Abas({ secoes, label = "Detalhes da ocorrência" }) {
  const [selecionada, setSelecionada] = useState(secoes[0]?.id);
  const ativa = secoes.some((s) => s.id === selecionada)
    ? selecionada
    : secoes[0]?.id;
  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <Tabs
        value={ativa}
        onChange={(_, v) => setSelecionada(v)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label={label}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        {secoes.map((s) => (
          <Tab
            key={s.id}
            value={s.id}
            id={`aba-${s.id}`}
            aria-controls={`painel-${s.id}`}
            icon={s.icon ? <Icon fontSize="small">{s.icon}</Icon> : undefined}
            iconPosition="start"
            label={s.label}
            sx={{ minHeight: 60 }}
          />
        ))}
      </Tabs>
      {secoes.map((s) => (
        <Box
          role="tabpanel"
          id={`painel-${s.id}`}
          aria-labelledby={`aba-${s.id}`}
          hidden={ativa !== s.id}
          key={s.id}
          sx={{ p: { xs: 2, md: 3 }, minWidth: 0 }}
        >
          {ativa === s.id && s.content}
        </Box>
      ))}
    </Card>
  );
}
export function EstadoConsulta({ query, children }) {
  if (query.isLoading)
    return (
      <Box role="status" sx={{ py: 4 }}>
        <LinearProgress />
        <Typography sx={{ mt: 1 }}>Carregando informações…</Typography>
      </Box>
    );
  if (query.error)
    return (
      <Alert severity="error">
        {query.error.message ||
          "Não foi possível consultar os dados. Tente atualizar a consulta."}
      </Alert>
    );
  return (
    <>
      {query.isFetching && <LinearProgress sx={{ mb: 1 }} />}
      {children}
    </>
  );
}
export function Campo({ label, value }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography sx={{ overflowWrap: "anywhere" }}>
        {value === null || value === undefined || value === ""
          ? "Não informado"
          : value}
      </Typography>
    </Box>
  );
}
export function Codigo({ children }) {
  return (
    <Box
      component="pre"
      sx={{
        p: 2,
        bgcolor: "grey.50",
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        whiteSpace: "pre-wrap",
        overflowWrap: "anywhere",
        maxHeight: 480,
        overflow: "auto",
        fontSize: 12
      }}
    >
      {children}
    </Box>
  );
}
